module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMiAyVjExSDEwLjhWMTJIMS4yQzAuNTQgMTIgMCAxMS41NSAwIDExVjJIMS4yWk03LjggMy41SDExLjFMNy44IDAuNzVWMy41Wk0zLjYgMEg4LjRMMTIgM1Y5QzEyIDkuNTU1IDExLjQ2NiAxMCAxMC44IDEwSDMuNkMzLjI4MTc0IDEwIDIuOTc2NTIgOS44OTQ2NCAyLjc1MTQ3IDkuNzA3MTFDMi41MjY0MyA5LjUxOTU3IDIuNCA5LjI2NTIyIDIuNCA5VjFDMi40IDAuNDQ1IDIuOTM0IDAgMy42IDBaTTkgOFY3SDMuNlY4SDlaTTEwLjggNlY1SDMuNlY2SDEwLjhaIiBmaWxsPSIjNTM1MzUzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/column-type/multiple_attachment.svg
// module id = Y5bH
// module chunks = 46